// extracted by mini-css-extract-plugin
export default {"label":"CheckWrapper_label__VwZ4V","container":"CheckWrapper_container__3PztF"};